
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
            <v-col cols="5">
              <v-text-field
              label="Nome do Evento"
              v-model="form.filters.nomeEvento"
              outlined
              dense
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-autocomplete
                v-model="form.filters.diaLetivo"
                label="Dia Letivo"
                item-text="descricao"
                item-value="value"
                outlined
                dense
                :items="$diaLetivo"
              ></v-autocomplete>
            </v-col>
            <sca-select-ativo
              :cols="2"
              :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
              v-model="form.filters.situacao"
            ></sca-select-ativo>
          </v-row>
          <v-row class="d-flex justify-center mt-3">
            <sca-date-picker
              :cols="2"
              label="Data Início"
              v-model="form.filters.dataInicio"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
            <sca-date-picker
            :cols="2"
              v-model="form.filters.dataFim"
              label="Data Final"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
          </v-row>
           <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headersAnalitico"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        sort-by="dataHora"
        :sort-desc="true"
      >
        <template v-slot:[`item.nomeEvento`]="{ item }">
          {{ item.nomeEvento }}
        </template>
        <template v-slot:[`item.diaLetivo`]="{ item }">
          {{ item.diaLetivo }}
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.situacao" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataHora`]="{ item }">
          {{ $formatarDataHora(item.dataHora) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorioPdf"
        @cancel="baixarCSVRelatorio"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
  import pageLoadingMixin from "mixins/page-loading.mixin";
  import RelatorioDeLog from "services/relatorios-log/manter-evento-calendario.service"
  export default {
      name: "RelatorioLogTurno",
      mixins: [pageLoadingMixin, RelatorioDeLog],

      data: () => ({
      onReport: false,
      expanded: [],
      form: {
          filters: {
              nomeEvento: null,
              diaLetivo: null,
              situacao: null,
              dataInicio: null,
              dataFim: null,
          },
          lists: {
              listRelatorios: [],
          },
      },
      headersAnalitico: [
          { text: "Evento", align: "center", value: "nomeEvento" },
          { text: "Dia Letivo", align: "center", value: "diaLetivoStr" },
          { text: "Situação", align: "center", value: "situacao" },
          { text: "Data/Hora da ação", align: "center", value: "dataHora" },
          { text: "Ação", align: "center", value: "acao" },
      ],
      }),
      methods: {
      async buscarRelatorios() {
          const isValid = this.validarDatas();
          if (!isValid) return;
          if (!this.verificarFiltrosPreenchidos()) return;
          const filtros = { ...this.form.filters };
          this.showPageLoading();
          try {
          const { data } = await this.$obterRelatorioLogEventoCalendario({ params: filtros });
          this.processarRespostaRelatorio(data);
          } finally {
          this.hidePageLoading();
          }
      },
      validarDatas() {
      const { dataInicio, dataFim } = this.form.filters;

      if (dataInicio && dataFim) {
        if (new Date(dataFim) < new Date(dataInicio)) {
          this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
          return false;
        }
        if (new Date(dataInicio) > new Date(dataFim)) {
          this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
          return false;
        }
      }
      return true;
    },

    verificarFiltrosPreenchidos() {
      const { nomeEvento, situacao, dataInicio, dataFim, diaLetivo } = this.form.filters;
      if (!nomeEvento && situacao == null && !dataInicio && !dataFim && diaLetivo == null) {
        this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
        return false;
      }
      return true;
    },

      async baixarCSVRelatorio() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogCSVEventoCalendario({ params: this.form.filters });
        this.$baixarRelatorioCSV(data, `SCA.RelatórioDeLogDeEventoCalendarioCSV`);
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      async baixarRelatorioPdf() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogPDFEventoCalendario({ params: this.form.filters });
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SCA.RelatórioDeLogDeEventoCalendario.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      processarRespostaRelatorio(data) {
        this.form.lists.listRelatorios = data.relatorio.lista;
      },

      resetForm() {
        this.form.filters.dataInicio = null;
        this.form.filters.dataFim = null;

        this.$nextTick(() => {
          this.$set(this.form.filters, 'dataInicio', null);
          this.$set(this.form.filters, 'dataFim', null);
        });
        this.form.filters.nomeEvento = null;
        this.form.filters.diaLetivo = null;
        this.form.filters.situacao = null;
        this.form.lists.listRelatorios = [];
      },
    },
  };
</script>
